var BxfPopoverTriggerEnum;
(function (BxfPopoverTriggerEnum) {
    BxfPopoverTriggerEnum["HOVER"] = "hover";
    BxfPopoverTriggerEnum["PRESSED"] = "pressed";
})(BxfPopoverTriggerEnum || (BxfPopoverTriggerEnum = {}));

export { BxfPopoverTriggerEnum as B };
